import { useQuery } from "@apollo/client/react";
import { StoreAnalyticsDocument } from "@/generated/graphql";
import type { StoreAnalytics } from "@/types/models";

export function useStoreAnalytics(since?: string) {
  const { data, loading, error, refetch } = useQuery(StoreAnalyticsDocument, {
    fetchPolicy: "network-only",
    variables: since ? { since } : {},
  });

  const analytics: StoreAnalytics | null = data?.storeAnalytics ?? null;

  return {
    data: analytics,
    loading,
    error,
    refetch,
  };
}
